import { DataBean } from "../DataBean";

export class CostingCenterHistory extends DataBean {


    public async addCostingCenterHistory(idContract:any,fromDate:any,costingCenterCode:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.CostingCenterHistory_addCostingCenterHistory_Number_java.util.Date_String", [idContract,fromDate,costingCenterCode]);
    }
   
  public async getCostingCenterHistoryCatalog(idAccount:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCostingCenterHistoryCatalog_Number", [idAccount]);
    }
    

 
}